import { parsePositiveInteger } from '@iconik-io/core/src/parse_positive_integer';

export function getQueryPage(searchParams: string) {
  const parsedQuery = new URLSearchParams(searchParams);
  return parsePositiveInteger(parsedQuery.get('page')) ?? 1;
}
